import { createContext, Dispatch } from 'react'

import { UIAction } from './actions'
import { UIState } from './types'

export const UIContext = createContext<UIState | undefined>(undefined)
export const UIDispatchContext = createContext<Dispatch<UIAction> | undefined>(undefined)
